module.exports = __webpack_public_path__ + "static/media/Kartak_video_smallest.5ffc8ef1.mov";